/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_PhoneInputs */

const en_form_phone = /** @type {(inputs: Form_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

const he_form_phone = /** @type {(inputs: Form_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טלפון`)
};

/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Form_PhoneInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const form_phone = /** @type {((inputs?: Form_PhoneInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_PhoneInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_phone(inputs)
	return he_form_phone(inputs)
});